import React from "react";
import classNames from "classnames";
import kebabCase from "lodash.kebabcase";
import { StampProps, StampStatus } from "./Stamp.types";
import { getDurationFromToday } from "./dateHelper";
import { AlertCircleIcon, AlertOctagonIcon } from "../icons";
import "./Stamp.scss";

const Stamp = React.forwardRef<HTMLDivElement, StampProps>(
  (
    { status, size = "large", variant = "hard", deadline, withIndicator },
    ref
  ) => {
    const variantStatuses = [
      StampStatus.early,
      StampStatus.onTime,
      StampStatus.late,
      StampStatus.veryLate,
    ];

    const duration = !!deadline ? getDurationFromToday(deadline) : null;

    const classes = classNames(
      "elemental-Stamp",
      `elemental-Stamp--${kebabCase(status)}`,
      {
        "elemental-Stamp--small":
          size === "small" &&
          variant === "soft" &&
          variantStatuses.includes(status),
        "elemental-Stamp--hard": variant === "hard",
        "elemental-Stamp--soft":
          variant === "soft" && variantStatuses.includes(status),
      }
    );

    const shouldDisplayEta =
      !!deadline &&
      status !== StampStatus.onTime &&
      variantStatuses.includes(status) &&
      variant === "hard";

    const shouldDisplayIndicator =
      withIndicator &&
      variantStatuses.includes(status) &&
      size === "large" &&
      variant === "hard";

    const addLeadingZero = (num: number): string => {
      return String(num).padStart(2, "0");
    };

    return (
      <div data-testid="stamp-component" className={classes} ref={ref}>
        <span>{status.toUpperCase()}</span>
        {shouldDisplayEta && (
          <span className="elemental-Stamp-time">
            by {addLeadingZero(duration?.days)}d{" "}
            {addLeadingZero(duration?.hours)}h{" "}
            {addLeadingZero(duration?.minutes)}m
          </span>
        )}
        {shouldDisplayIndicator &&
          (status === StampStatus.onTime ? (
            <AlertOctagonIcon data-testid="alert-octagon-icon" />
          ) : (
            <AlertCircleIcon data-testid="alert-circle-icon" />
          ))}
      </div>
    );
  }
);

export default Stamp;
